import React, { Fragment, useState, useContext, useEffect } from 'react'
import { UrlServicesContext } from 'components/UrlServicesContext'
import { Redirect } from 'react-router-dom'

import {
  Dialog,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  Grid,
  Snackbar,
  Slide,
  Button,
  Divider,
} from '@material-ui/core'
import MuiDialogContent from '@material-ui/core/DialogContent'
import MuiDialogActions from '@material-ui/core/DialogActions'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import axios from 'axios'
import Alert from '@material-ui/lab/Alert'
import Card from 'components/Card/Card.js'
import CardHeader from 'components/Card/CardHeader.js'
import CardBody from 'components/Card/CardBody.js'
import { CheckBox, Cancel, Save } from '@material-ui/icons'

import img from 'assets/img/loading.gif'

import {
  cardBodyStyle,
  GreenCheckboxSelected,
} from 'assets/jss/material-dashboard-react/components/cardBodyStyle'

const useStyles = makeStyles(cardBodyStyle)

const GreenCheckbox = withStyles(GreenCheckboxSelected)((props) => (
  <Checkbox color="default" {...props} />
))

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent)

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions)

const headCells = [
  {
    id: 'name',
    numeric: false,
    disablePadding: true,
    label: 'Dessert (100g serving)',
  },
]

function EnhancedTableHead(props) {
  const { name } = props
  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align="left"
            padding="normal"
            sortDirection={false}
            colSpan={2}
            style={{ background: '#F7F7F7' }}
          >
            <b>{name.name}</b>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}

export default function ViewProfilePrivilegesPsychometrics(props) {
  const classes = useStyles()
  const [selected, setSelected] = useState([])
  const [rowsModules, setRowsModules] = useState([])
  const [loader, setLoader] = useState(true)
  const [error, setError] = useState(false)
  const [success, setSuccess] = useState(false)
  const [openAlert, setOpenAlert] = useState(false)
  const [mensaje, setMensaje] = useState('')
  const [selectedDifferent, setSelectedDifferent] = useState([])
  const [selectedIdProfile, setSelectedIdProfile] = useState([])
  const [idProfileResources, setIdProfileResources] = useState([])
  const [returnLogin, setReturnLogin] = React.useState(false)
  const [viewSelectTest, setViewSelectTest] = React.useState(false)
  const [selectedViewTest, setSelectedViewTest] = React.useState(false)
  const [disabled, setDisabled] = React.useState(false)

  let keyAuthorization = localStorage.getItem('Session')

  const { urlServices, keyAplication } = useContext(UrlServicesContext)

  let idUser = props.id.users.filter(
    (filtered) =>
      props.id.id === filtered.accountId &&
      props.id.documentId === filtered.documentId
  )  

  useEffect(() => {
    axios
      .get(`${urlServices}tests-types-tpm`, {
        headers: {
          application: keyAplication,
          Authorization: 'Bearer ' + keyAuthorization,
        },
      })
      .then((response) => {
        /* let resoult = response.data.rows.sort(function (a, b) {
          if (a.order > b.order) {
            return 1;
          }
          if (a.order < b.order) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });*/
        setRowsModules(response.data.rows)

        // console.log(idUser[0])

        if (idUser.length > 0) {
          let rsl = [],
            rsl2 = []

          idUser[0].testsUsersTpm.map((row) => {
            if (row.testId === 21 && row.viewTest === 1) {
              setSelectedViewTest(true)
            }

            rsl.push(row.testId)
            rsl2.push({ id: row.id, testId: row.testId })
          })

          handleSelectTest(21, rsl)

          setSelected(rsl)
          setSelectedDifferent(rsl)
          setSelectedIdProfile(rsl2)
          setIdProfileResources(idUser[0].testsUsersTpm)
        }

        setLoader(false)
      })
      .catch((e) => {
        if (e.response.status === 401) {
          setTimeout(() => {
            localStorage.clear()
            setReturnLogin(true)
          }, 200)
        } else {
          setError(true)
        }
      })
  }, [])

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id)
    let newSelected = []

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id)
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1))
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1))
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      )
    }

    handleSelectTest(id, newSelected)

    setSelected(newSelected)
  }

  const handleSelectTest = (id, selects) => {
    if (id === 21) {
      let result = selects.filter((filtered) => filtered === id)
      setViewSelectTest(result.length > 0 ? true : false)
    }
  }

  const isSelected = (id) => selected.indexOf(id) !== -1

  const handleSave = (pro) => (event) => {
    var different = [],
      deleteValue = []     

    for (var i0 = 0; i0 < selected.length; i0++) {
      var found0 = false

      for (var j0 = 0; j0 < selectedDifferent.length; j0++) {
        // j < is missed;
        if (selected[i0] === selectedDifferent[j0]) {
          found0 = true
          break
        }
      }
      if (found0 === false) {
        different.push(selected[i0])
      }

      if (selected[i0] === 21) {
        for (var i = 0; i < idProfileResources.length; i++) {
          if (idProfileResources[i].testId === 21) {
            UpdateData(idProfileResources[i].id)
          }
        }
      }
    }

    for (var i = 0; i < selectedDifferent.length; i++) {
      var found = false

      for (var j = 0; j < selected.length; j++) {
        // j < is missed;
        if (selectedDifferent[i] === selected[j]) {
          found = true
          break
        }
      }
      if (found === false) {
        deleteValue.push(selectedDifferent[i])
      }
    }

    if (different.length > 0) {
      let result = []

      different.map((row) => {
        result = idProfileResources.filter(
          (filtered) => filtered.testId === row
        )

        if (result.length === 0) {
          CreateData(row)
        } else {
          for (var i = 0; i < idProfileResources.length; i++) {
            if (idProfileResources[i].testId === row) {
              UpdateData(idProfileResources[i].id)
            }
          }
        }
      })
    }

    if (deleteValue.length > 0) {
      let out = []

      for (var i = 0; i < selectedIdProfile.length; i++) {
        for (var j = 0; j < deleteValue.length; j++) {
          // j < is missed;
          if (selectedIdProfile[i].testId === deleteValue[j]) {
            out.push(selectedIdProfile[i])
          }
        }
      }

      DeleteData(out)
    }
    setMensaje('Registro guardado con éxito.')
    setOpenAlert(true)
    setSuccess('success')
    setDisabled(true)
  }

  const DeleteData = (data) => {
    //console.log(data);
    data.map((row) => {
      axios
        .delete(`${urlServices}tests-users-tpm/${row.id}`, {
          headers: {
            application: keyAplication,
            Authorization: 'Bearer ' + keyAuthorization,
          },
        })
        .then(
          (response) => {
            props.callBackRefresh()
          },
          (error) => {}
        )
        .catch((e) => {
          if (e.response.status === 401) {
            setTimeout(() => {
              localStorage.clear()
              setReturnLogin(true)
            }, 200)
          } else {
            console.log(e)
          }
        })
    })
  }

  const CreateData = (id) => {
    const dataValue = {
      clientId: idUser[0].id,
      testId: id,
      viewTest: id === 21 ? (selectedViewTest ? 1 : 0) : 0,
    }

    axios
      .post(`${urlServices}tests-users-tpm`, dataValue, {
        headers: {
          application: keyAplication,
          Authorization: 'Bearer ' + keyAuthorization,
        },
      })
      .then(
        (response) => {
          props.callBackRefresh()
        },
        (error) => {}
      )
      .catch((e) => {
        if (e.response.status === 401) {
          setTimeout(() => {
            localStorage.clear()
            setReturnLogin(true)
          }, 200)
        } else {
          console.log(e)
        }
      })
  }

  const UpdateData = (row) => {
    const dataValue = {
      //status: 1,
      viewTest: selectedViewTest ? 1 : 0,
    }

    axios
      .put(`${urlServices}tests-users-tpm/${row}`, dataValue, {
        headers: {
          application: keyAplication,
          Authorization: 'Bearer ' + keyAuthorization,
        },
      })
      .then(
        (response) => {
          props.callBackRefresh()
        },
        (error) => {}
      )
      .catch((e) => {
        if (e.response.status === 401) {
          setTimeout(() => {
            localStorage.clear()
            setReturnLogin(true)
          }, 200)
        } else {
          console.log(e)
        }
      })
  }

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    setOpenAlert(false)
  }

  const handleCloseDialog = (pro) => (event) => {
    props.exit()
  }

  if (returnLogin) {
    return <Redirect to="/" />
  }

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      aria-labelledby="customized-dialog-title"
      open={props.open}
      onClose={handleCloseDialog(true)}
      keepMounted
      scroll="body"
      style={{ zIndex: 100 }}
      PaperProps={{
        classes: { root: classes.DialogStyle },
      }}
    >
      <DialogContent dividers className={classes.styleDialogContent}>
        <Card>
          <CardHeader color="info">
            <div className={classes.cardTitleWhite}>
              <CheckBox className={classes.iconWhite} /> Seleccionar pruebas
              psicométricas para el cliente
            </div>
          </CardHeader>
          <CardBody>
            <Grid container>
              {error ? (
                <Grid item xs={12} sm={12}>
                  <Alert severity="error">
                    Error en la consulta con sel servidor.
                  </Alert>
                </Grid>
              ) : (
                ''
              )}
              {loader ? (
                <Grid item xs={12} sm={12}>
                  <center>
                    <img
                      src={img}
                      alt="loader"
                      style={{
                        width: 60,
                        margin: '100px 0',
                      }}
                    />
                  </center>
                </Grid>
              ) : (
                <Fragment>
                  {rowsModules.map((row1, i1) => {
                    return (
                      <Grid item xs={12} sm={3} key={i1}>
                        <Paper className={classes.paper}>
                          <TableContainer>
                            <Table
                              aria-labelledby="tableTitle"
                              size="small"
                              aria-label="enhanced table"
                            >
                              <EnhancedTableHead name={row1} />
                              <TableBody>
                                {row1.teststpm
                                  .sort(function (a, b) {
                                    if (a.order > b.order) {
                                      return 1
                                    }
                                    if (a.order < b.order) {
                                      return -1
                                    }
                                    // a must be equal to b
                                    return 0
                                  })
                                  .map((row, index) => {
                                    const labelId = `enhanced-table-checkbox-${index}`
                                    let isItemSelected = isSelected(row.id)
                                    return (
                                      <Fragment>
                                        <TableRow
                                          hover
                                          onClick={(event) =>
                                            handleClick(event, row.id)
                                          }
                                          role="checkbox"
                                          aria-checked={isItemSelected}
                                          tabIndex={-1}
                                          key={row.id}
                                          selected={isItemSelected}
                                          style={{ cursor: 'pointer' }}
                                        >
                                          <TableCell padding="checkbox">
                                            <GreenCheckbox
                                              checked={isItemSelected}
                                              inputProps={{
                                                'aria-labelledby': labelId,
                                              }}
                                            />
                                          </TableCell>
                                          <TableCell
                                            component="th"
                                            id={labelId}
                                            scope="row"
                                            padding="none"
                                            style={{
                                              fontSize: 12,
                                              padding: '4px 4px 4px 0',
                                            }}
                                          >
                                            {row.name}
                                          </TableCell>
                                        </TableRow>
                                      </Fragment>
                                    )
                                  })}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Paper>
                      </Grid>
                    )
                  })}
                </Fragment>
              )}
              <Grid item xs={12} sm={12}>
                <Divider style={{ marginTop: 50 }} />
              </Grid>
              <Grid item xs={12} sm={6} style={{ padding: 5 }}>
                {viewSelectTest ? (
                  <>
                    <b style={{ fontSize: 16 }}>Habilitar </b>
                    <Table
                      aria-labelledby="tableTitle1"
                      size="small"
                      aria-label="enhanced table"
                    >
                      <TableBody>
                        <TableRow
                          hover
                          //  onClick={(event) => handleClick(event, row.id)}
                          role="checkbox"
                          //  aria-checked={isItemSelected}
                          tabIndex={-1}
                          //  key={row.id}
                          //  selected={isItemSelected}
                        >
                          <TableCell padding="checkbox">
                            <GreenCheckbox
                              checked={selectedViewTest}
                              onClick={() =>
                                setSelectedViewTest(!selectedViewTest)
                              }
                            />
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            padding="none"
                            style={{
                              fontSize: 14,
                              padding: '4px 4px 4px 0',
                            }}
                          >
                            Ver prueba (CEQ) realizada del candidato
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </>
                ) : (
                  ''
                )}
              </Grid>
            </Grid>
          </CardBody>
        </Card>
        <Snackbar
          open={openAlert}
          autoHideDuration={6000}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          onClose={handleClose}
        >
          <Slide direction="up" in={openAlert} mountOnEnter unmountOnExit>
            <Alert
              onClose={handleClose}
              severity={success === 'error' ? 'error' : 'success'}
              elevation={6}
              variant="filled"
            >
              {mensaje}
            </Alert>
          </Slide>
        </Snackbar>
      </DialogContent>
      <DialogActions>
        <Button
          type="submit"
          className={classes.buttonSubmit}
          onClick={handleSave()}
          startIcon={<Save />}
          disabled={disabled}
        >
          Guardar
        </Button>
        <Button onClick={handleCloseDialog(true)}>
          <Cancel />
        </Button>
      </DialogActions>
    </Dialog>
  )
}
